"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BadgeDivider = exports.BadgeDividerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
exports.BadgeDividerDefaultProps = {
  lineVariant: 'solid'
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 32px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    height: 32px;\n    position: relative;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: ", ";\n    color: ", ";\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('dark'))
});
var LineStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    width: 100%;\n    top: 15px;\n    margin: 0;\n    border: none;\n\n    ", "\n\n    ", "\n  "], ["\n    position: absolute;\n    width: 100%;\n    top: 15px;\n    margin: 0;\n    border: none;\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return props.variant === 'solid' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom: 1px solid ", ";\n    "], ["\n      border-bottom: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-mid'));
  }, function (props) {
    return props.variant === 'dotted' && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: 2px;\n      margin-top: -1px;\n      ", ";\n    "], ["\n      height: 2px;\n      margin-top: -1px;\n      ", ";\n    "])), theme_1.theme.H_DOT_BG_END('line-mid', 1.5));
  })
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    z-index: 20;\n    margin: 0;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: 18px;\n    background: ", ";\n    padding: 0 ", ";\n    line-height: 1.35em;\n    height: 30px;\n    font-size: 1em;\n    text-transform: capitalize;\n  "], ["\n    z-index: 20;\n    margin: 0;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    position: relative;\n    border: 1px solid ", ";\n    border-radius: 18px;\n    background: ", ";\n    padding: 0 ", ";\n    line-height: 1.35em;\n    height: 30px;\n    font-size: 1em;\n    text-transform: capitalize;\n  "])), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(10))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Line: styled_components_1.default.hr.attrs({
    className: 'shp-badge-divider__line'
  })(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LineStyles),
  Badge: styled_components_1.default.h4.attrs({
    className: 'shp-badge-divider__badge'
  })(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
exports.BadgeDivider = react_1.default.forwardRef(function (props, ref) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick,
    lineVariant = props.lineVariant;
  return react_1.default.createElement(My.Container, {
    ref: ref,
    onClick: onClick,
    className: className
  }, react_1.default.createElement(My.Line, {
    variant: lineVariant
  }), react_1.default.createElement(My.Badge, null, children));
});
exports.BadgeDivider.defaultProps = exports.BadgeDividerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;